export const RECORDS = 'records';
export const FORM = 'form';
export const COMBO = 'combo';
export const HTML = 'html';
export const NAVCALENDAR = 'nav_calendar';
export const BUTTONBAR = 'buttonbar';
export const VBUTTONBAR = 'vbuttonbar';
export const DUTYROSTER = 'dutyroster';
